import React from 'react'
import injectSheet from 'react-jss'
import styles from './sticky-editor.styles'
import classNames from 'classnames'
import { EditorProvider, Controls, Editor } from '..'

const StickyEditor = ({
  classes,
  editorState,
  onChange,
  controls,
  className,
  placeholder,
  error,
  ...props
}) => (
  <EditorProvider editorState={editorState} onChange={onChange}>
    <div className={classNames(classes.container, className)}>
      <Controls.Panel className={classes.panel}>{controls}</Controls.Panel>
      <Editor error={error} className={classes.editor} {...props} />
    </div>
  </EditorProvider>
)

export default injectSheet(styles)(StickyEditor)
